import { Representative } from "src/common/types/representative";
import { AnyAction } from "redux";
import { internalActionKeys } from "../actions/internalActionKeys";
import { repsCompareFunc } from "./serviceRepresentativesReducer";

export default function branchAdminsReducer(state: Representative[] = [], action: AnyAction): Representative[] {
  switch (action.type) {
    case internalActionKeys.GET_BRANCH_ADMINS_SUCCESS:
      return [...action.admins].sort(repsCompareFunc);
    case internalActionKeys.PATCH_BRANCH_ADMINS_SUCCESS:
      return [...action.admins].sort(repsCompareFunc);
    default:
      return state;
  }
}
